import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMunicipalityConfig } from "./municipalityConfig";
import { ConfigState } from "./configTypes";

const initialState : ConfigState = {
    loading: false,
    error: ''
}

const configSlice = createSlice({
    name: 'configSlice',
    initialState,
    reducers: {
        configLoading: (state) => {
            state.loading = true;
            state.error = undefined;
            state.config = undefined;
        },
        configLoaded: (state, action: PayloadAction<IMunicipalityConfig>) => {
            state.loading = false;
            state.config = action.payload;
            state.error = undefined;
        },
        configError: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.config = undefined
            state.error = action.payload;            
        }
    }
})

export const { configLoaded, configLoading, configError } = configSlice.actions;
export default configSlice.reducer